var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { useMemo, useState } from 'react';
import Sheet from 'sheet-happens';
import { useLanguage } from '@base/LanguageProvider';
import { ColumnMetaDataContext, ColumnMetaDateFormat, ImportJobStatus, } from '@common/api';
import FSButton from '@components/FSButton';
import Manager from '@shared/modal/Manager';
import { CircledChevronDown, getIconAsHTMLImageElement } from '@shared/icons/icons';
import { useImportJobRouteParams } from '@data/hooks/importJobsRouteParams';
import { useImportJobTableData } from '@data/hooks/importJobTableData';
import { useBatchUpdateImportJobRows, useImportJobs } from '@data/importJob/importJobActions';
import useTableCells from '@hooks/useTableCells';
import useTheme from '@styled/useTheme';
import ImportJobHeader from './ImportJobHeader';
import ColumnEditModal from './ColumnEditModal';
import { convertDateToImportFormat, globalLoadingWrapped, parseDateWithImportFormat } from './util';
var DEFAULT_COLUMN_WIDTH = 150;
var columnMetaDataContextDescriptionMap = (_a = {},
    _a[ColumnMetaDataContext.IDENTIFIER] = 'Table',
    _a[ColumnMetaDataContext.TIMEPOINT] = 'Value for month',
    _a[ColumnMetaDataContext.VALUES] = 'Value',
    _a[ColumnMetaDataContext.DATETIME] = 'Date',
    _a[ColumnMetaDataContext.DESCRIPTION] = 'Description',
    _a[ColumnMetaDataContext.CUSTOM] = 'Custom field',
    _a);
function createHeaders(columnMetas, importJob, iconColor) {
    var iconWidth = 16;
    var iconHeight = 16;
    var iconImage = getIconAsHTMLImageElement(React.createElement(CircledChevronDown, { color: iconColor }));
    /* add btns to first row */
    return columnMetas.map(function (columnMeta, columnIndex) {
        var headerContent = {
            items: [],
        };
        var typeDescription = columnMetaDataContextDescriptionMap[columnMeta.dataContext];
        var headerTitle = typeDescription !== undefined ? "".concat(columnMeta.name, " (").concat(typeDescription, ")") : columnMeta.name;
        headerContent.items.push({
            x: 0,
            y: 0,
            content: headerTitle,
            horiozntalAlign: 'left',
        });
        headerContent.items.push({
            x: 0,
            y: -iconHeight / 2,
            width: iconWidth,
            height: iconHeight,
            content: iconImage,
            horiozntalAlign: 'right',
            onClick: function () {
                Manager.closeModal();
                Manager.renderModal(React.createElement(ColumnEditModal, { importJob: importJob, columnIndex: columnIndex }));
            },
        });
        return headerContent;
    });
}
function ImportJobSheet(_a) {
    var _this = this;
    var importJob = _a.importJob;
    var _b = useLanguage(), parseLocaleDate = _b.parseLocaleDate, parseLocaleNumber = _b.parseLocaleNumber, formatLocaleDate = _b.formatLocaleDate;
    var theme = useTheme();
    var columnMetas = importJob.metadata.columnMetas;
    var tableData = useImportJobTableData(importJob);
    var batchUpdateImportJobRows = useBatchUpdateImportJobRows(importJob.id);
    var _c = __read(useState({}), 2), userChanges = _c[0], setUserChanges = _c[1];
    var _d = useTableCells(new Array(columnMetas.length).fill(DEFAULT_COLUMN_WIDTH)), cellWidth = _d.cellWidth, cellHeight = _d.cellHeight, onCellWidthChange = _d.onCellWidthChange, onCellHeightChange = _d.onCellHeightChange;
    var tableHeaders = useMemo(function () { return createHeaders(columnMetas, importJob, theme.colors.primary.w500); }, [columnMetas, importJob]);
    var importJobEditable = importJob.status === ImportJobStatus.CREATED || importJob.status === ImportJobStatus.REVERTED;
    var onSelectionChanged = function () { };
    var onRightClick = function () { };
    var columnHeaderStyle = {
        fontFamily: 'Inter',
        fontSize: 12,
        weight: 'bold',
        color: theme.colors.ui.dark,
        backgroundColor: theme.colors.primary.w50,
    };
    var cellStyle = function (columnIndex, rowIndex) {
        var _a, _b;
        var cellStyle = {
            fontFamily: 'Inter',
            fontSize: 12,
            color: theme.colors.ui.dark,
        };
        var thisRowInfo = tableData[rowIndex];
        if (thisRowInfo === undefined) {
            return cellStyle;
        }
        var thisCellStyleData = (_a = thisRowInfo.style) === null || _a === void 0 ? void 0 : _a[columnIndex];
        if (thisCellStyleData === 'tag') {
            // color detected tags
            cellStyle.color = theme.colors.primary.w500;
        }
        else if (thisCellStyleData === 'number') {
            // align numbers
            cellStyle.textAlign = 'right';
        }
        // check for user changes
        var thisCellChange = (_b = userChanges[thisRowInfo.rowId]) === null || _b === void 0 ? void 0 : _b[columnIndex];
        if (thisCellChange !== undefined) {
            // color user changes
            cellStyle.color = theme.colors.warning.w500;
            if (thisCellChange === null) {
                cellStyle.backgroundColor = theme.colors.warning.w50;
            }
        }
        return cellStyle;
    };
    var readOnly = function (columnIndex, rowIndex) {
        if (!importJobEditable) {
            return true;
        }
        if (rowIndex >= tableData.length) {
            // no existing row
            return true;
        }
        if (columnIndex >= tableHeaders.length) {
            // no existing column
            return true;
        }
        // data can be edited
        return false;
    };
    var onChange = function (sheetChanges) {
        var e_1, _a;
        var userChangesCopy = __assign({}, userChanges);
        try {
            for (var sheetChanges_1 = __values(sheetChanges), sheetChanges_1_1 = sheetChanges_1.next(); !sheetChanges_1_1.done; sheetChanges_1_1 = sheetChanges_1.next()) {
                var sheetChange = sheetChanges_1_1.value;
                var originalRow = tableData[sheetChange.y];
                if (originalRow === undefined) {
                    // don't save any changes if row doesn't exist
                    continue;
                }
                var columnMeta = columnMetas[sheetChange.x];
                if (columnMeta === undefined) {
                    // don't save any changes if column doesn't exist
                    continue;
                }
                // copy previous changes or original values (if no changes have been made)
                var rowChangesCopy = __assign({}, userChangesCopy[originalRow.rowId]);
                var rawValue = sheetChange.value;
                if (rawValue === null) {
                    rowChangesCopy[sheetChange.x] = null;
                }
                else {
                    if (columnMeta.dataContext === ColumnMetaDataContext.VALUES ||
                        columnMeta.dataContext === ColumnMetaDataContext.TIMEPOINT) {
                        // column has numbers -> try to parse value
                        var parsedValue = typeof rawValue === 'number' ? rawValue : parseLocaleNumber(rawValue);
                        if (Number.isNaN(parsedValue)) {
                            // parsing failed
                            rowChangesCopy[sheetChange.x] = null;
                        }
                        else {
                            rowChangesCopy[sheetChange.x] = parsedValue;
                        }
                    }
                    else if (columnMeta.dataContext === ColumnMetaDataContext.DATETIME) {
                        // column has dates -> try to parse it
                        var parsedDate = typeof rawValue === 'string'
                            ? parseLocaleDate(rawValue) // given value is a string -> parse it with locale format
                            : parseDateWithImportFormat(rawValue, ColumnMetaDateFormat.EXCEL); // given value is a number -> parse it as excel serial date
                        if (parsedDate === null) {
                            rowChangesCopy[sheetChange.x] = null;
                        }
                        else {
                            var dateInImportFormat = convertDateToImportFormat(parsedDate, columnMeta.dateFormat);
                            rowChangesCopy[sheetChange.x] = dateInImportFormat;
                        }
                    }
                    else {
                        rowChangesCopy[sheetChange.x] = rawValue;
                    }
                }
                userChangesCopy[originalRow.rowId] = rowChangesCopy;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sheetChanges_1_1 && !sheetChanges_1_1.done && (_a = sheetChanges_1.return)) _a.call(sheetChanges_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        setUserChanges(userChangesCopy);
    };
    var displayData = function (columnIndex, rowIndex) {
        // fetch data
        var importJobRow = tableData[rowIndex];
        if (importJobRow === undefined) {
            // empty cell if no import job row exists on this index
            return null;
        }
        // show changed values if changes were made
        var rowChanges = userChanges[importJobRow.rowId];
        if (rowChanges !== undefined) {
            var change = rowChanges[columnIndex];
            if (change !== undefined) {
                var thisColumnMeta = columnMetas[columnIndex];
                if (change !== null && thisColumnMeta.dataContext === ColumnMetaDataContext.DATETIME) {
                    // format dates for display (tableDate will have already formatted ones)
                    // change value must remain same to properly update raw value in row
                    var parsedDate = parseDateWithImportFormat(change, thisColumnMeta.dateFormat);
                    if (parsedDate === null) {
                        return null;
                    }
                    else {
                        var formattedDate = formatLocaleDate(parsedDate);
                        return formattedDate;
                    }
                }
                else {
                    return change;
                }
            }
        }
        // return original value
        var data = importJobRow.formattedRowData[columnIndex];
        return data;
    };
    var sourceData = function (x, y) {
        return displayData(x, y);
    };
    var editData = function (x, y) {
        var data = displayData(x, y);
        if (data === null) {
            return '';
        }
        else {
            return String(data);
        }
    };
    var saveChanges = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return __awaiter(_this, void 0, void 0, function () {
                        var mappedUpdateData, _loop_1, _a, _b, _c, rowIdString, rowChanges;
                        var e_2, _d;
                        return __generator(this, function (_e) {
                            switch (_e.label) {
                                case 0:
                                    mappedUpdateData = [];
                                    _loop_1 = function (rowIdString, rowChanges) {
                                        var e_3, _f;
                                        var rowId = Number.parseInt(rowIdString);
                                        if (rowChanges === undefined || Number.isNaN(rowId)) {
                                            return "continue";
                                        }
                                        var originalRow = tableData.find(function (rowInfo) { return rowInfo.rowId === rowId; });
                                        if (originalRow === undefined) {
                                            return "continue";
                                        }
                                        var updatedRowData = __spreadArray([], __read(originalRow.originalRowData), false);
                                        try {
                                            for (var _g = (e_3 = void 0, __values(Object.entries(rowChanges))), _h = _g.next(); !_h.done; _h = _g.next()) {
                                                var _j = __read(_h.value, 2), indexString = _j[0], newValue = _j[1];
                                                var index = Number.parseInt(indexString);
                                                if (newValue === undefined || Number.isNaN(index)) {
                                                    continue;
                                                }
                                                updatedRowData[index] = newValue;
                                            }
                                        }
                                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                        finally {
                                            try {
                                                if (_h && !_h.done && (_f = _g.return)) _f.call(_g);
                                            }
                                            finally { if (e_3) throw e_3.error; }
                                        }
                                        mappedUpdateData.push({ id: rowId, data: updatedRowData });
                                    };
                                    try {
                                        for (_a = __values(Object.entries(userChanges)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                            _c = __read(_b.value, 2), rowIdString = _c[0], rowChanges = _c[1];
                                            _loop_1(rowIdString, rowChanges);
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                    // call api with update data
                                    return [4 /*yield*/, batchUpdateImportJobRows.mutateAsync(mappedUpdateData)];
                                case 1:
                                    // call api with update data
                                    _e.sent();
                                    // reset frontend changes
                                    setUserChanges({});
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var undoChanges = function () {
        setUserChanges({});
    };
    return (React.createElement("div", { className: "importjob-content" },
        React.createElement(Sheet, { onSelectionChanged: onSelectionChanged, onRightClick: onRightClick, columnHeaders: tableHeaders, columnHeaderStyle: columnHeaderStyle, editData: editData, displayData: displayData, sourceData: sourceData, cellStyle: cellStyle, cellWidth: cellWidth, onCellWidthChange: onCellWidthChange, cellHeight: cellHeight, onCellHeightChange: onCellHeightChange, onChange: onChange, readOnly: readOnly }),
        Object.keys(userChanges).length > 0 && (React.createElement("div", { style: {
                position: 'absolute',
                right: 20,
                display: 'flex',
                justifyContent: 'space-between',
                width: 170,
            } },
            React.createElement(FSButton, { title: "Save", onClick: saveChanges }),
            React.createElement(FSButton, { title: "Undo", "$type": "secondary", onClick: undoChanges })))));
}
export default function ImportJobSingle() {
    var _a;
    var L = useLanguage().L;
    var importJobId = useImportJobRouteParams().importJobId;
    var importJobsQuery = useImportJobs();
    var importJobs = (_a = importJobsQuery.data) !== null && _a !== void 0 ? _a : [];
    var selectedImportJob = importJobs.find(function (ij) { return ij.id === importJobId; });
    if (selectedImportJob !== undefined) {
        // found the selected import job
        return (React.createElement("div", { className: "fs-import-container" },
            React.createElement(ImportJobHeader, { importJob: selectedImportJob }),
            React.createElement(ImportJobSheet, { importJob: selectedImportJob })));
    }
    // query loading - show nothing (will refresh once loaded)
    if (importJobsQuery.isLoading || importJobsQuery.isFetching || importJobsQuery.isRefetching) {
        return (React.createElement("div", { className: "fs-import-container" },
            React.createElement("div", { className: "import-new-intro" },
                React.createElement("h2", { style: { textAlign: 'center' } }, L('Loading import jobs')))));
    }
    // selected import job data not found
    return (React.createElement("div", { className: "fs-import-container" },
        React.createElement("div", { className: "import-new" },
            React.createElement("div", { className: "import-new-intro" },
                React.createElement("h2", { style: { textAlign: 'center' } }, L('Selected job does not exist')),
                React.createElement("p", null, L('Go back to Import'))),
            React.createElement("div", { className: "import-new-browse" },
                React.createElement(FSButton, { title: "Back to Import", onClick: function () {
                        window.location.hash = '/import';
                    } })))));
}
